module.exports = __webpack_public_path__ + "images/[2]Premium_Exterieurs_17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/slider/[2]Premium_Exterieurs_17.jpg
// module id = 34
// module chunks = 0